import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../utils/auth";
import { useTranslation } from "react-i18next";
import {
  logoutIcon,
  moonIcon,
  profileIcon,
  settingsIcon,
  superadminIcon,
} from "../constants/icons";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";
import { clearSPAuthTokens } from "../../helpers/spauth_token_helper";

function NavUserProfileDropDown({preview_as_user}) {
  const tmp_profile_image = useSelector((state) => state.config.tmp_profile_image);
  const us_name = useSelector((state) => state.admin.us_name);
  const user_path = useSelector((state) => state.user.paths.user_path);
  const profileData = useSelector((state) => state.admin);
  const configData = useSelector((state) => state.config);
  const wrapperRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [colorScheme, setColorScheme] = useState("light");
  const [dropDownToggle, setDropDownToggle] = useState(false);
  useOutsideAlerter(wrapperRef, setDropDownToggle);

  const onDropDownClick = (toggle, e) => {
    if (e.target.classList.contains("user-profile")) {
      return setDropDownToggle((dropToggle) => !dropToggle);
    }
    setDropDownToggle(toggle);
  };

  useEffect(() => {
    try {
      const colorScheme = localStorage.getItem("color-scheme");
      if (colorScheme) {
        setColorScheme(colorScheme);
        document.documentElement.setAttribute("data-color-mode", colorScheme);
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  const onLogoutClick = (e) => {
    e.preventDefault();
    // dispatch(resetAdminData());
    logout();
    navigate("/login");
  };

  const onThemeChange = (e) => {
    try {
      const checked = e.target.checked;
      let colorScheme = checked ? "dark" : "light";
      document.documentElement.setAttribute("data-color-mode", colorScheme);
      setColorScheme(colorScheme);
      localStorage.setItem("color-scheme", colorScheme);
    } catch (e) {
      console.log(e);
    }
  };

  let dropDownClasses = "dropdown-menu mw-dropdown-default dropdown-menu-end";
  if (dropDownToggle) {
    dropDownClasses += " show";
  }

  /* PROFILE */
  let profileImage;
  if (configData.session.us_image) {
    if(tmp_profile_image == '') {
      if(configData.session.us_image == 'default.jpg') {
        profileImage = <img src={`${configData.s3_url}uploads/default/user/${configData.session.us_image}`} width="150" alt="Profile" />;
      } else {
        profileImage = <img src={`${user_path}${configData.session.us_image}`} width="150" alt="Profile" />;
      }
    } else {
      profileImage = <img src={`${tmp_profile_image}`} width="150" alt="Profile" />;
    }
  } else if (configData.session.us_name) {
    profileImage = configData.session.us_name[0];
  }

  const handlelogout = (e) => {
    e.preventDefault();
    const origin = window.location.origin;
    localStorage.removeItem('profileSkipped');
    clearSPAuthTokens('SPAUTH_');
    if (preview_as_user === "preview_as_user") {
      window.location.assign(`${origin}/logout/admin_as_user/`);
    }
    else {
      window.location.assign(`${origin}/logout`);
    }
  }

  return (
    <div
      ref={wrapperRef}
      className="dropdown dropdown-select"
      onClick={onDropDownClick.bind(null, true)}
    >
      <div
        data-testid="profileicon"
        className="circle-wrap circle-wrap-md bg-circle-primary text-white user-profile"
        data-bs-toggle="dropdown"
        data-bs-offset="0,7"
        aria-expanded={dropDownToggle}
      >
        {profileImage}
      </div>
      <ul
        data-testid="profiledropdown"
        className={dropDownClasses}
        aria-labelledby="dropdownMenuButton1"
        data-bs-popper="none"
      >
        {/* <li>
          <a className="dropdown-item" href="#top">
            {superadminIcon}
            {` ${t("Superadmin")}`}
          </a>
        </li> */}
        <li>
          <a className="dropdown-item" href="/student-dashboard/learner-profile">
            {profileIcon}
            {` ${t("Profile")}`}
          </a>
        </li>
        <li>
          <a className="dropdown-item" href="/student-dashboard/settings">
            {settingsIcon}
            {` ${t("Settings")}`}
          </a>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        <li>
          <div className="d-grid align-items-center py-2 mode-switcher dropdown-item">
            {moonIcon}
            <span className="mx-1">{t("Dark")} </span>
            <label className="form-switch">
              <input
                type="checkbox"
                data-testid="themeswitcher"
                checked={colorScheme === "dark"}
                onChange={onThemeChange}
              />
              <span className="form-switch-slider"></span>
            </label>
          </div>
        </li>
        <li>
          <hr className="dropdown-divider" />
        </li>
        <li>
          <a className="dropdown-item" onClick={handlelogout}>
            {logoutIcon}
            {` ${t("Log out")}`}
          </a>
        </li>
      </ul>
    </div>
  );
}

export default NavUserProfileDropDown;
